import { Location } from '@angular/common';
import { Component, HostBinding, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'belender-support-number',
  templateUrl: './support-number.component.html',
  styleUrls: ['./support-number.component.scss']
})
export class SupportNumberComponent {
  /** Dialog mode cancels the .mat-dialog-container padding (see _help-page.scss). */
  @HostBinding('class.is-dialog') isDialog = false;

  constructor(
    private location: Location,
    @Optional() private dialogRef: MatDialogRef<SupportNumberComponent>,
  ) {
    this.isDialog = !!this.dialogRef;
  }

  /** "Volver al formulario": closes the help dialog or, when routed, goes back in history. */
  back(event?: Event) {
    event?.preventDefault();
    if (this.dialogRef) {
      this.dialogRef.close(true);
    } else {
      this.location.back();
    }
  }
}
